export const bankingRoutes = [
    {
        path: 'banking/new-account',
        name: 'NewBankAccount',
        component: () => import('./views/NewBankAccount.vue'),
    },

    {
        path: 'banking/transfer-fund',
        name: 'TransferFund',
        component: () => import('./views/TransferFund.vue'),
    },
    {
        path: 'banking/pay-credit-card',
        name: 'PayCreditCard',
        component: () => import('./views/PayCreditCard.vue'),
    },
    {
        path: 'banking/reconciliations-history',
        name: 'ReconciliationsHistory',
        component: () => import('./views/ReconciliationsHistory.vue'),
    },
    {
        path: 'banking/credit-cards/add',
        name: 'AddCreditCard',
        component: () => import('./views/AddCreditCard.vue'),
    },
    {
        path: 'banking/credit-cards/edit/:cardId',
        name: 'EditCreditCard',
        component: () => import('./views/AddCreditCard.vue'),
    },
    {
        path: 'banking/credit-cards/details',
        name: 'CreditCardsDetails',
        component: () => import('./views/CreditCardsDetails.vue'),
    },
    {
        path: 'banking/credit-cards',
        redirect: { name: 'CreditCardsDetails' },
    },
    {
        path: 'banking/loans/lenders/add',
        name: 'AddLoanLender',
        component: () => import('./views/AddLoanLender.vue'),
    },
    {
        path: 'banking/loans/lenders/edit/:lenderId',
        name: 'EditLoanLender',
        component: () => import('./views/AddLoanLender.vue'),
    },
    {
        path: 'banking/loans/lenders/details',
        name: 'LoanLendersDetails',
        component: () => import('./views/LoanLendersDetails.vue'),
    },
    {
        path: 'banking/loans/lenders',
        redirect: { name: 'LoanLendersDetails' },
    },
    {
        path: 'banking/loans/add',
        name: 'AddLoan',
        component: () => import('./views/AddLoan.vue'),
    },
    {
        path: 'banking/loans/edit/:loanId',
        name: 'EditLoan',
        component: () => import('./views/AddLoan.vue'),
    },
    {
        path: 'banking/loans/record-payment',
        name: 'RecordLoanPayment',
        component: () => import('./views/RecordLoanPayment.vue'),
    },
    {
        path: 'banking/loans/details',
        name: 'LoansDetails',
        component: () => import('./views/LoansDetails.vue'),
    },
    {
        path: 'banking/loans',
        redirect: { name: 'LoansDetails' },
    },
    {
        path: 'banking/organization-loans/organizations/add',
        name: 'AddOrganizationLoanLender',
        component: () => import('./views/AddOrganizationLoanLender.vue'),
    },
    {
        path: 'banking/organization-loans/organizations/edit/:lenderId',
        name: 'EditOrganizationLoanLender',
        component: () => import('./views/AddOrganizationLoanLender.vue'),
    },
    {
        path: 'banking/organization-loans/organizations/details',
        name: 'OrganizationLoanLendersDetails',
        component: () => import('./views/OrganizationLoanLendersDetails.vue'),
    },
    {
        path: 'banking/organization-loans/organizations',
        redirect: { name: 'OrganizationLoanLendersDetails' },
    },
    {
        path: 'banking/organization-loans/add',
        name: 'AddOrganizationLoan',
        component: () => import('./views/AddOrganizationLoan.vue'),
    },
    {
        path: 'banking/organization-loans/edit/:loanId',
        name: 'EditOrganizationLoan',
        component: () => import('./views/AddOrganizationLoan.vue'),
    },
    {
        path: 'banking/organization-loans/record-payment',
        name: 'RecordOrganizationLoanPayment',
        component: () => import('./views/RecordOrganizationLoanPayment.vue'),
    },
    {
        path: 'banking/organization-loans/record-collection',
        name: 'RecordOrganizationLoanCollection',
        component: () => import('./views/RecordOrganizationLoanPayment.vue'),
    },
    {
        path: 'banking/organization-loans/details',
        name: 'OrganizationLoansDetails',
        component: () => import('./views/OrganizationLoansDetails.vue'),
    },
    {
        path: 'banking/organization-loans',
        redirect: { name: 'OrganizationLoansDetails' },
    },
    {
        path: 'banking/accounts',
        name: 'BankAccountsList',
        component: () => import('./views/BankAccountsList.vue'),
    },
    {
        path: 'banking/make-deposit',
        name: 'MakeDeposit',
        component: () => import('./views/MakeDeposit.vue'),
    },
    {
        path: 'banking/transactions/:accountId',
        name: 'BankTransactions',
        component: () => import('./views/BankTransactions.vue'),
    },
    {
        path: 'banking/transaction-history/:accountId',
        name: 'BankTransactionHistory',
        component: () => import('./views/BankTransactionHistory.vue'),
    },
];
